

import React from "react";
import { useEffect, useState } from "react";

const OnlineUsersDetails = ({ list }) => {
    
    return(
        <center>
            <b>Online Users Details</b><br/>
                { 
                    list && list.map((o, index) => {
                        return (
                            
                                <div key={ index }>
                                    {/* { o.path } - { o.Username } - { o.device.toLowerCase() === "true" ? "📱" : "🖥️" }  */}
                                    { o.path } - { o.device.toLowerCase() === "true" ? "📱" : "🖥️" } 
                                </div>
                            
                        )
                    })
                }
        </center>
    )
}

export default OnlineUsersDetails;